import * as React from 'react';
import * as classnames from 'classnames';
import { namespacedClassnames } from '../../../common/namespace-classes';
export var ContainerSection = function (props) {
    var defaultClasses = namespacedClassnames('container-section');
    var classNames = classnames(defaultClasses, props.className);
    return React.createElement("div", { className: classNames }, props.children);
};
//# sourceMappingURL=container-section.js.map